module.exports = __webpack_public_path__ + "static/media/intro.7e8cc6c2.mp3";